import {
  getAssetDisplayTitle,
  getAssetFlightTimesStart,
  getAssetShortPath,
  getAssetTeaserDescription,
  isAssetUpcoming,
  isLiveStream,
} from '../shared/helpers/assetHelpers.ts';

import type {
  SvpAsset,
  SvpAssetAdditional,
} from '@vgtv/api-client/lib/svp_asset';

export const getAssetPublishedDate = (asset: SvpAsset) => {
  if (isLiveStream(asset) || isAssetUpcoming(asset)) {
    return undefined;
  }

  return getAssetFlightTimesStart(asset) || asset.published;
};

/**
 * Returns a subset of asset properties to be used on various components, e.g.
 * AssetsList, AssetsSlider, etc.
 */
export function getAssetProps(asset: SvpAssetAdditional) {
  const duration = isAssetUpcoming(asset) ? undefined : asset.duration;

  const publishedDate = getAssetPublishedDate(asset);

  const title = getAssetDisplayTitle(asset);
  const description = getAssetTeaserDescription(asset);
  const shortPath = getAssetShortPath(asset);

  return {
    duration,
    publishedDate,
    title,
    shortPath,
    description,
  };
}
